import { render, staticRenderFns } from "./Whatsnew.vue?vue&type=template&id=6443f684&"
import script from "./Whatsnew.vue?vue&type=script&lang=js&"
export * from "./Whatsnew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports